import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CoreState } from "../../state";
import { Jurisdiction, JurisdictionTranslatePrefix } from "../jurisdiction.model";
import { JurisdictionSelector } from "../jurisdiction.selector";

@Injectable({
	providedIn: "root",
})
export class JurisdictionPrefixService {
	constructor(
		private store: Store<CoreState>,
		private translateService: TranslateService
	) {}

	addJurisdictionPrefix$(value: string): Observable<string> {
		return this.getJurisdictionPrefix$().pipe(
			map((jurisdiction) => (jurisdiction ? `${jurisdiction}.${value}` : value))
		);
	}

	getJurisdictionPrefix$(): Observable<string> {
		return this.store.select(JurisdictionSelector.get).pipe(map((jurisdiction) => this.getPrefix(jurisdiction)));
	}

	translateByJurisdictionPrefix$(defaultCrsKey: string, interpolateParams?: object): Observable<string> {
		return this.getJurisdictionPrefix$().pipe(
			map((jurisdiction) => {
				const prefixedKey =
					jurisdiction === JurisdictionTranslatePrefix.Mga
						? defaultCrsKey
						: `${jurisdiction}.${defaultCrsKey}`;
				const content = this.translateService.instant(prefixedKey, interpolateParams);

				if (content !== prefixedKey) {
					return content;
				}

				return this.translateService.instant(defaultCrsKey, interpolateParams);
			})
		);
	}

	private getPrefix(jurisdiction: Jurisdiction | undefined): string {
		switch (jurisdiction) {
			case Jurisdiction.Ukgc:
				return JurisdictionTranslatePrefix.Ukgc;
			case Jurisdiction.Sga:
				return JurisdictionTranslatePrefix.Sga;
			case Jurisdiction.Dga:
				return JurisdictionTranslatePrefix.Dga;
			case Jurisdiction.Iaui:
				return JurisdictionTranslatePrefix.Iaui;
			case Jurisdiction.Mta:
				return JurisdictionTranslatePrefix.Mta;
			case Jurisdiction.Dgoj:
				return JurisdictionTranslatePrefix.Dgoj;
			case Jurisdiction.Hgc:
				return JurisdictionTranslatePrefix.Hgc;
			case Jurisdiction.Cgl:
				return JurisdictionTranslatePrefix.Cgl;
			case Jurisdiction.Reda:
				return JurisdictionTranslatePrefix.Reda;
			case Jurisdiction.Lotba:
				return JurisdictionTranslatePrefix.Lotba;
			case Jurisdiction.Ksa:
				return JurisdictionTranslatePrefix.Ksa;
			case Jurisdiction.COGA:
				return JurisdictionTranslatePrefix.COGA;
			case Jurisdiction.Conajzar:
				return JurisdictionTranslatePrefix.Conajzar;
			case Jurisdiction.Tgc:
				return JurisdictionTranslatePrefix.Tgc;
			default:
				return JurisdictionTranslatePrefix.Mga;
		}
	}
}
